import trackEvent from '$utils/track-event';
import { attachLiveValidation, validateInput } from '$utils/validation';

const initFormHandler = () => {
  const form = document.querySelector('form');

  if (!form) return;

  form.setAttribute('novalidate', 'true');

  const inputs = form?.querySelectorAll<HTMLInputElement>(
    'input:not([type="submit"]):not([name="end_date"]):not([name="date-range"]), textarea, select'
  );

  form.addEventListener('submit', (event) => {
    event.preventDefault(); // prevent actual form submission
    event.stopImmediatePropagation();

    const currentUrl = new URL(window.location.href);
    const oldParams = new URLSearchParams(currentUrl.search);
    const updatedParams = oldParams.toString().replace(/\+/g, '%20');

    const formData = new FormData(form);
    const params = new URLSearchParams();

    // Parse check-in and check-out from trip_dates
    const tripDates = String(formData.get('trip_dates')); // format: "2025-05-08 - 2025-06-18"
    const [checkin, checkout] = tripDates?.split(' - ') || [];

    // Get values
    const rooms = formData.get('rooms') || '9'; // fallback if missing
    const eventType = formData.get('eventType') || 'other'; // optional
    const description = formData.get('description') || '';

    // Add params to URLSearchParams
    if (!oldParams.has('referral')) {
      params.set('referral', 'MKT - Website Direct');
    }
    if (rooms) params.set('rooms', String(rooms));
    if (checkin) params.set('checkin', checkin.trim());
    if (checkout) params.set('checkout', checkout.trim());
    if (eventType) params.set('eventType', String(eventType));
    if (description) params.set('description', String(description));

    let hasErrors = false;

    inputs?.forEach((input) => {
      const isValid = validateInput(input);
      if (!isValid) {
        attachLiveValidation(input); // attach listeners if error is shown
        hasErrors = true;
      }
    });

    if (!hasErrors) {
      let baseUrl = '';
      const redirectElement =
        form.parentElement?.querySelector('a[data-redirect]') ||
        document.querySelector('a[data-redirect]');

      if (redirectElement) {
        const href = redirectElement.getAttribute('href');
        if (href && href.trim() && href !== '#') {
          // Extract base URL from the data-redirect href (remove query params)
          try {
            const url = new URL(href);
            baseUrl = `${url.protocol}//${url.host}${url.pathname}`;
          } catch (e) {
            console.error('redirect to default', e);

            // If URL parsing fails, fall back to default logic
            baseUrl = '';
          }
        }
      }

      // Fall back to default URLs if no valid redirect URL found
      if (!baseUrl) {
        baseUrl =
          window.location.hostname === 'engine.com'
            ? 'https://groups.engine.com/new-trip'
            : 'https://groups.engine-stg.com/new-trip';
      }

      // Merge old query params with new ones
      const finalParams = new URLSearchParams(updatedParams);
      for (const [key, value] of params.entries()) {
        finalParams.set(key, value); // override with new values if duplicated
      }

      const redirectUrl = `${baseUrl}?${finalParams.toString()}`;

      const props = {
        redirectUrl,
        currentUrl: window.location.href,
      };

      trackEvent('Groups Form Submit', props);

      window.location.href = redirectUrl;
    }
  });
};

export default initFormHandler;
